import { z } from 'zod'

import { OperationLevelPermission } from '../auth-claims/permissions'
import { defineApi } from '../http'
import { streamScopedPathSchema } from './shared'

export const locateByLonLatApi = defineApi({
  pathSchema: streamScopedPathSchema,
  pathFor: (p) => `${p.requestType}/streams/${p.orgCode}/${p.streamId}/diagnostics/locate`,
  name: 'LocateRecordByCoordinate',
  description: 'Find the record ID for a given longitude/latitude coordinate in a stream',
  requiredPermissions: OperationLevelPermission.ViewApplicationData,
  method: 'POST',
  requestBodySchema: z.tuple([z.number(), z.number()]),
  responseSchema: z.object({ record_id: z.number() }),
  supportsCodec: true
})
